/**
 * Sleek's rarity palette (partner Figma 2026-10-08): the chip tint and the
 * glow behind a card on the reveal and on the Vault card page. Same hues as
 * the odds sheet's bars; each tier is its own `SleekRarity` knob.
 */
const RARITY_COLORS: Record<string, string> = {
  common: 'var(--co-SleekRarity-common, #6D707C)',
  uncommon: 'var(--co-SleekRarity-uncommon, #97D926)',
  rare: 'var(--co-SleekRarity-rare, #0DA7F2)',
  epic: 'var(--co-SleekRarity-epic, #DF203C)',
  legendary: 'var(--co-SleekRarity-legendary, #F2830D)',
  grail: 'var(--co-SleekRarity-grail, #F2B50D)',
  mythic: 'var(--co-SleekRarity-mythic, #8442F0)',
};

/** The colour for a badge name as the backend sends it ("Mythic", …); null
 *  for a card without a badge or with one outside the seven tiers. */
export function sleekRarityColor(badgeName: string | null | undefined): string | null {
  if (!badgeName) return null;
  return RARITY_COLORS[badgeName.trim().toLowerCase()] ?? null;
}
